<!-- 处理需要根据接口动态渲染的表单元素 -->
<template>
  <div>
    <!--文本类型-->
    <el-input
        v-if="formItem.dataType === 'Text'"
        v-model.trim="ItemValue[formItem.code]"
        :placeholder="formItem.placeholder||'请输入'"
        :clearable="!formItem.hideClear"
        @change="handleChange"
    >
      <span
          v-if="formItem.unitSymbol"
          class="el-input__icon"
          slot="suffix">
          {{formItem.unitSymbol}}
        </span>
    </el-input>
    <!--整数类型-->
    <el-input
        v-if="formItem.dataType === 'Int'"
        v-model.number.trim="ItemValue[formItem.code]"
        oninput="value=value.replace(/[^\d]/g,'')"
        :placeholder="formItem.placeholder||'请输入'"
        :clearable="!formItem.hideClear"
        @change="handleChange"
    >
      <span
          v-if="formItem.unitSymbol"
          class="el-input__icon"
          slot="suffix">
          {{formItem.unitSymbol}}
        </span>
    </el-input>
    <!--小数类型-->
    <el-input
        v-if="formItem.dataType === 'Number'"
        v-model.trim="ItemValue[formItem.code]"
        :placeholder="formItem.placeholder||'请输入'"
        :clearable="!formItem.hideClear"
        @input.native="(e)=>{e.target.value=handleNumber(e.target.value,formItem.code)}"
        @change="handleChange"
    >
      <span
          v-if="formItem.unitSymbol"
          class="el-input__icon"
          slot="suffix">
          {{formItem.unitSymbol}}
        </span>
    </el-input>
    <!--枚举类型-->
    <el-select
        v-if="formItem.dataType === 'Enum'"
        v-model="ItemValue[formItem.code]"
        :placeholder="formItem.placeholder||'请选择'"
        :clearable="!formItem.hideClear"
        @change="handleChange"
        :filterable="formItem.filterable"
    >
      <el-option v-for="opt in formItem.values" :key="opt.code" :label="opt.name" :value="opt.code" />
    </el-select>
    <!--布尔类型-->
    <el-select
        v-if="formItem.dataType === 'Bool'"
        v-model="ItemValue[formItem.code]"
        :placeholder="formItem.placeholder||'请选择'"
        :clearable="!formItem.hideClear"
        @change="handleChange"
    >
      <el-option label="是" :value="true" />
      <el-option label="否" :value="false" />
    </el-select>
    <!--范围类型-->
    <div class="range" v-if="formItem.dataType === 'Range'">
      <el-input class="range-input" :class="{'range-input-error':rangeError}" placeholder="最小值" v-model.trim="ItemValue[formItem.code][0]" @change="checkValue">
        <span
          v-if="formItem.unitSymbol"
          class="el-input__icon"
          slot="suffix">
          {{formItem.unitSymbol}}
        </span>
      </el-input> -
      <el-input class="range-input" :class="{'range-input-error':rangeError}" placeholder="最大值" v-model.trim="ItemValue[formItem.code][1]" @change="checkValue">
        <span
          v-if="formItem.unitSymbol"
          class="el-input__icon"
          slot="suffix">
          {{formItem.unitSymbol}}
        </span>
      </el-input>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchFormItems',
  props: {
    // {code,dataType,name}
    formItem: {
      type: Object,
      default() {
        return {}
      }
    },
    initValue: {
      type: [String, Number, Boolean, Array],
      default: ''
    },
    numberFunc: {
      type: Function,
      default: (value) => {
        value = value.replace(/[^\d.]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace(/(\.\d+)\./g, '$1').replace(/^0+(\d)/g, '$1').replace(/(\d+\.[\d]{2}).*$/g, '$1')
        return value
      }
    }
  },
  data() {
    return {
      // 单个输入框的值
      ItemValue: {},
      rangeError: false
    }
  },
  watch: {
    initValue: {
      handler() {
        this.ItemValue = {
          [this.formItem.code]: this.initValue
        }
      },
      immediate: true
    }
  },
  methods: {
    // 表单内容发生变化
    handleChange() {
      this.$emit('change', this.ItemValue)
    },
    handleNumber(value, code) {
      const handledValue = this.numberFunc(value)
      this.ItemValue[code] = handledValue
      return handledValue
    },
    checkValue() {
      const [firstValue, secondValue] = this.ItemValue[this.formItem.code]
      this.rangeError = !(Number(firstValue) < Number(secondValue) || !firstValue || !secondValue)
      this.handleChange()
    }
  }
}
</script>

<style scoped lang="less">
/deep/.el-input__suffix{
    color: #909399;

  }
.range-input{
  width: 96px;
  &.range-input-error{
    /deep/ .el-input__inner{
      border: 1px solid red;
    }
  }
  
}

</style>
